"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var PanelHeader = function PanelHeader(_ref) {
  var title = _ref.title,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? null : _ref$isOpen,
      _ref$newStyle = _ref.newStyle,
      newStyle = _ref$newStyle === void 0 ? false : _ref$newStyle,
      togglePanel = _ref.togglePanel,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass;
  var icon = isOpen ? newStyle ? 'chevronUp' : 'arrowDropUp' : newStyle ? 'chevronDown' : 'arrowDropdown';
  var iconSize = newStyle ? 24 : 18;
  return (0, _preact.h)("div", {
    onClick: function onClick() {
      return togglePanel && togglePanel();
    },
    className: (0, _classnames.default)({
      'panel-heading': true,
      'panel-heading--collapsible': collapsible
    }, customClass)
  }, title, collapsible ? (0, _preact.h)(_assets.default, {
    customClass: "icon-toggle-panel",
    icon: icon,
    width: iconSize,
    height: iconSize
  }) : null);
};

var _default = PanelHeader;
exports.default = _default;